import React, { ReactElement, useMemo } from 'react';

import { RBAC_DISABLED_MESSAGE } from '../../constants/strings';
import useHasPermission from '../../hooks/useHasPermission';
import { RbacPermissions } from '../../../core/interfaces/user';
import { HdLinkProps } from '../../../link/components/link/HdLink';
import { HdTooltip } from '../../../tooltip/HdTooltip';
import { HdLink } from '../../../components';

export interface HdRbacLinkProps extends HdLinkProps {
  rbacPermission: RbacPermissions;
  tooltipContent?: ReactElement | string;
  disabledToolTipContent?: ReactElement | string;
  dataId?: string;
}

export const HdRbacLink: React.FC<HdRbacLinkProps> = React.forwardRef(
  (
    {
      disabled = false,
      rbacPermission,
      tooltipContent,
      disabledToolTipContent,
      dataId,
      ...props
    }: HdRbacLinkProps,
    ref
  ) => {
    const { hasPermission } = useHasPermission();
    const isRbacActionEnabled = hasPermission(rbacPermission);

    const tooltip = useMemo(() => {
      if (!isRbacActionEnabled) {
        return RBAC_DISABLED_MESSAGE;
      }

      if (disabled) {
        return disabledToolTipContent;
      }

      return tooltipContent;
    }, [disabled, disabledToolTipContent, isRbacActionEnabled, tooltipContent]);

    const isButtonDisabled = !isRbacActionEnabled || disabled;
    return (
      <HdTooltip title={tooltip} disabled={!tooltip}>
        <span>
          <HdLink
            dataId={dataId}
            style={isButtonDisabled ? { pointerEvents: 'none' } : null}
            disabled={isButtonDisabled}
            {...props}
            ref={ref}
          />
        </span>
      </HdTooltip>
    );
  }
);
